export const ycAdmissionsTeamAsCandidates = [
  {
    photoUrl:
      "https://www.ycombinator.com/assets/ycdc/people/regan-ab33b8632b6fdff39ac23f489b78bc0d69d3774050ff6238e371bb93ffafb0d6.jpg",
    fullName: "Regan Bell",
    role: "Product Engineer",
    percentageMatch: 90,
    currentTitle: "Product Engineer",
    currentCompany: "Y Combinator",
    location: "San Francisco, CA",
    linkedinUrl: "https://www.linkedin.com/in/regan-bell",
    websiteUrl: "https://reganbell.com",
    githubUrl: "https://github.com/reganbell",
    twitterUrl: "https://twitter.com/reganbell",
    resumeUrl: "https://reganbell.com/resume.pdf",
    coverLetterUrl: "https://reganbell.com/cover-letter.pdf",
    rankings: {
      educationPercentage: 92,
      experiencePercentage: 78,
      technicalSkillsPercentage: 95,
      objectivesPercentage: 74,
      companyFitPercentage: 83,
      locationFitPercentage: 80,
    },
    desiredCompensation: 146890,
    interpersonalCharacteristics: [
      "Team player",
      "Communicative",
      "Detail-oriented",
    ],
    technicalSkills: ["Java", "Python", "JavaScript"],
  },
  {
    photoUrl:
      "https://www.ycombinator.com/assets/ycdc/people/eve-bf6fa4c3b2f778434081f5e539c7872f2590831df62c82a59dfb4ee22e110b75.jpg",
    fullName: "Eve Bouffard",
    role: "Admissions Associate",
    percentageMatch: 99,
    currentTitle: "Admissions Associate",
    currentCompany: "Y Combinator",
    location: "San Francisco, CA",
    linkedinUrl: "https://www.linkedin.com/in/eve-bouffard",
    websiteUrl: "https://evebouffard.com",
    githubUrl: "https://github.com/evebouffard",
    twitterUrl: "https://twitter.com/evebouffard",
    resumeUrl: "https://evebouffard.com/resume.pdf",
    coverLetterUrl: "https://evebouffard.com/cover-letter.pdf",
    rankings: {
      educationPercentage: 71,
      experiencePercentage: 95,
      technicalSkillsPercentage: 98,
      objectivesPercentage: 83,
      companyFitPercentage: 87,
      locationFitPercentage: 95,
    },
    desiredCompensation: 122068,
    interpersonalCharacteristics: [
      "Team player",
      "Communicative",
      "Detail-oriented",
    ],
    technicalSkills: ["Java", "Python", "JavaScript"],
  },
  {
    photoUrl:
      "https://www.ycombinator.com/assets/ycdc/people/steve-bd0a5851af984450e9c1dc182eb58696ef73e8a05a436853f7a5e2c2e46b7769.jpg",
    fullName: "Steve Bunting",
    role: "Product Engineer",
    percentageMatch: 70,
    currentTitle: "Product Engineer",
    currentCompany: "Y Combinator",
    location: "San Francisco, CA",
    linkedinUrl: "https://www.linkedin.com/in/steve-bunting",
    websiteUrl: "https://stevebunting.com",
    githubUrl: "https://github.com/stevebunting",
    twitterUrl: "https://twitter.com/stevebunting",
    resumeUrl: "https://stevebunting.com/resume.pdf",
    coverLetterUrl: "https://stevebunting.com/cover-letter.pdf",
    rankings: {
      educationPercentage: 86,
      experiencePercentage: 93,
      technicalSkillsPercentage: 84,
      objectivesPercentage: 74,
      companyFitPercentage: 78,
      locationFitPercentage: 77,
    },
    desiredCompensation: 85768,
    interpersonalCharacteristics: [
      "Team player",
      "Communicative",
      "Detail-oriented",
    ],
    technicalSkills: ["Java", "Python", "JavaScript"],
  },
  {
    photoUrl:
      "https://www.ycombinator.com/assets/ycdc/people/coco-2a181bcbe360b7e42153c2fe3231596ea241492e92633608e6e3e6238e95e942.jpg",
    fullName: "Carolyn Conway",
    role: "Admissions Manager & Software Engineer",
    percentageMatch: 97,
    currentTitle: "Admissions Manager & Software Engineer",
    currentCompany: "Y Combinator",
    location: "San Francisco, CA",
    linkedinUrl: "https://www.linkedin.com/in/carolyn-conway",
    websiteUrl: "https://carolynconway.com",
    githubUrl: "https://github.com/carolynconway",
    twitterUrl: "https://twitter.com/carolynconway",
    resumeUrl: "https://carolynconway.com/resume.pdf",
    coverLetterUrl: "https://carolynconway.com/cover-letter.pdf",
    rankings: {
      educationPercentage: 95,
      experiencePercentage: 89,
      technicalSkillsPercentage: 73,
      objectivesPercentage: 95,
      companyFitPercentage: 88,
      locationFitPercentage: 97,
    },
    desiredCompensation: 137850,
    interpersonalCharacteristics: [
      "Team player",
      "Communicative",
      "Detail-oriented",
    ],
    technicalSkills: ["Java", "Python", "JavaScript"],
  },
  {
    photoUrl:
      "https://www.ycombinator.com/assets/ycdc/people/josh-282bf5b20b57ba88e7bf6ef274d7c4c7819d8d65802f2c02f750df9c4887504d.jpg",
    fullName: "Josh France",
    role: "Product Engineer",
    percentageMatch: 94,
    currentTitle: "Product Engineer",
    currentCompany: "Y Combinator",
    location: "San Francisco, CA",
    linkedinUrl: "https://www.linkedin.com/in/josh-france",
    websiteUrl: "https://joshfrance.com",
    githubUrl: "https://github.com/joshfrance",
    twitterUrl: "https://twitter.com/joshfrance",
    resumeUrl: "https://joshfrance.com/resume.pdf",
    coverLetterUrl: "https://joshfrance.com/cover-letter.pdf",
    rankings: {
      educationPercentage: 93,
      experiencePercentage: 72,
      technicalSkillsPercentage: 84,
      objectivesPercentage: 76,
      companyFitPercentage: 70,
      locationFitPercentage: 90,
    },
    desiredCompensation: 99162,
    interpersonalCharacteristics: [
      "Team player",
      "Communicative",
      "Detail-oriented",
    ],
    technicalSkills: ["Java", "Python", "JavaScript"],
  },
  {
    photoUrl:
      "https://www.ycombinator.com/assets/ycdc/people/tommy-669a32a4ea6d8d4d6ff3d1017866174fa17ba22f7a21d6ce670f7b5ae04b55c7.jpg",
    fullName: "Tommy Kilmer",
    role: "Director of Admissions",
    percentageMatch: 78,
    currentTitle: "Director of Admissions",
    currentCompany: "Y Combinator",
    location: "San Francisco, CA",
    linkedinUrl: "https://www.linkedin.com/in/tommy-kilmer",
    websiteUrl: "https://tommykilmer.com",
    githubUrl: "https://github.com/tommykilmer",
    twitterUrl: "https://twitter.com/tommykilmer",
    resumeUrl: "https://tommykilmer.com/resume.pdf",
    coverLetterUrl: "https://tommykilmer.com/cover-letter.pdf",
    rankings: {
      educationPercentage: 99,
      experiencePercentage: 97,
      technicalSkillsPercentage: 98,
      objectivesPercentage: 81,
      companyFitPercentage: 90,
      locationFitPercentage: 94,
    },
    desiredCompensation: 87885,
    interpersonalCharacteristics: [
      "Team player",
      "Communicative",
      "Detail-oriented",
    ],
    technicalSkills: ["Java", "Python", "JavaScript"],
  },
  {
    photoUrl:
      "https://www.ycombinator.com/assets/ycdc/people/pennino-1110fc98250b5675c8d121673497bb29e432fc40000f5006f01fe4da159e085f.jpg",
    fullName: "Sean Pennino",
    role: "Admissions Manager",
    percentageMatch: 70,
    currentTitle: "Admissions Manager",
    currentCompany: "Y Combinator",
    location: "San Francisco, CA",
    linkedinUrl: "https://www.linkedin.com/in/sean-pennino",
    websiteUrl: "https://seanpennino.com",
    githubUrl: "https://github.com/seanpennino",
    twitterUrl: "https://twitter.com/seanpennino",
    resumeUrl: "https://seanpennino.com/resume.pdf",
    coverLetterUrl: "https://seanpennino.com/cover-letter.pdf",
    rankings: {
      educationPercentage: 95,
      experiencePercentage: 86,
      technicalSkillsPercentage: 99,
      objectivesPercentage: 95,
      companyFitPercentage: 76,
      locationFitPercentage: 82,
    },
    desiredCompensation: 120111,
    interpersonalCharacteristics: [
      "Team player",
      "Communicative",
      "Detail-oriented",
    ],
    technicalSkills: ["Java", "Python", "JavaScript"],
  },
  {
    photoUrl:
      "https://www.ycombinator.com/assets/ycdc/people/jeff-004a49a35eaec280f6be7c09d31cdd79f36dc69f32bc0d3c713c5e6f5e266459.jpg",
    fullName: "Jeff Peterson",
    role: "Product Engineer",
    percentageMatch: 97,
    currentTitle: "Product Engineer",
    currentCompany: "Y Combinator",
    location: "San Francisco, CA",
    linkedinUrl: "https://www.linkedin.com/in/jeff-peterson",
    websiteUrl: "https://jeffpeterson.com",
    githubUrl: "https://github.com/jeffpeterson",
    twitterUrl: "https://twitter.com/jeffpeterson",
    resumeUrl: "https://jeffpeterson.com/resume.pdf",
    coverLetterUrl: "https://jeffpeterson.com/cover-letter.pdf",
    rankings: {
      educationPercentage: 90,
      experiencePercentage: 70,
      technicalSkillsPercentage: 98,
      objectivesPercentage: 97,
      companyFitPercentage: 86,
      locationFitPercentage: 80,
    },
    desiredCompensation: 112336,
    interpersonalCharacteristics: [
      "Team player",
      "Communicative",
      "Detail-oriented",
    ],
    technicalSkills: ["Java", "Python", "JavaScript"],
  },
  {
    photoUrl:
      "https://www.ycombinator.com/assets/ycdc/people/steph-af6b11e61b7a3c55b099c780fe0a359236ceaab496850b530d178aedb8cefb2c.jpg",
    fullName: "Stephanie Simon",
    role: "Managing Admissions Officer",
    percentageMatch: 90,
    currentTitle: "Managing Admissions Officer",
    currentCompany: "Y Combinator",
    location: "San Francisco, CA",
    linkedinUrl: "https://www.linkedin.com/in/stephanie-simon",
    websiteUrl: "https://stephaniesimon.com",
    githubUrl: "https://github.com/stephaniesimon",
    twitterUrl: "https://twitter.com/stephaniesimon",
    resumeUrl: "https://stephaniesimon.com/resume.pdf",
    coverLetterUrl: "https://stephaniesimon.com/cover-letter.pdf",
    rankings: {
      educationPercentage: 96,
      experiencePercentage: 98,
      technicalSkillsPercentage: 87,
      objectivesPercentage: 79,
      companyFitPercentage: 83,
      locationFitPercentage: 90,
    },
    desiredCompensation: 120104,
    interpersonalCharacteristics: [
      "Team player",
      "Communicative",
      "Detail-oriented",
    ],
    technicalSkills: ["Java", "Python", "JavaScript"],
  },
];
